import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-edit-icon',
  templateUrl: 'edit-icon.component.html'
})
export class EditIconComponent {
  constructor() {}
}
